import React from "react"
import {Row,Col} from "react-bootstrap";
import DateTimeWidok from "./datetimewidok"

const ShowOdliczanie = ({ dni, godziny, minuty, sekundy }) => {
    return (
      <Col xs ={12} className="show-counter">
        <Row>
          <DateTimeWidok value={dni} type={'Dni'} isDanger={false} />
          <DateTimeWidok value={godziny} type={'Godziny'} isDanger={false} />
          <DateTimeWidok value={minuty} type={'Minuty'} isDanger={false} />
          <DateTimeWidok value={sekundy} type={'Sekundy'} isDanger={false} />
        </Row> 
      </Col>
    )
  }
export default ShowOdliczanie
